import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "Card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Join Us", -1)
const _hoisted_4 = { class: "formfield" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "formfield" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "formfield" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "formfield" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { style: {"color":"green"} }
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usernamefieldR) = $event)),
            placeholder: "Username"
          }, null, 512), [
            [_vModelText, _ctx.usernamefieldR]
          ]),
          _hoisted_5
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userpasswordfieldR) = $event)),
            placeholder: "Password"
          }, null, 512), [
            [_vModelText, _ctx.userpasswordfieldR]
          ]),
          _hoisted_8
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userfirstname) = $event)),
                Size: "10",
                placeholder: "First Name"
              }, null, 512), [
                [_vModelText, _ctx.userfirstname]
              ])
            ]),
            _hoisted_11,
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userlastname) = $event)),
                Size: "10",
                placeholder: "Last Name"
              }, null, 512), [
                [_vModelText, _ctx.userlastname]
              ])
            ])
          ])
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.useremail) = $event)),
            placeholder: "Email"
          }, null, 512), [
            [_vModelText, _ctx.useremail]
          ]),
          _hoisted_14
        ]),
        _hoisted_15,
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.register_user && _ctx.register_user(...args)))
        }, "SignUp"),
        _hoisted_16
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.SuccessR), 1),
        _hoisted_18,
        _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.ErrorR), 1)
      ])
    ])
  ]))
}